export default {"src":"/_next/static/media/expand.2005f280.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};